import React from "react";
import { Link } from "react-router-dom";
import { Lock, Users, Star, MapPin, Clock, Edit3, Trash2 } from "lucide-react";

const MOOD_LABEL = {
  ansioso: "ansioso", curioso: "curioso", calmo: "calmo",
  entusiasmado: "entusiasmado", cansado: "cansado",
  romantico: "romântico", neutro: "neutro",
};

const fmtDate = (d) => {
  if (!d) return "";
  try {
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return d; }
};

const EncounterCard = ({ encounter, onEdit, onDelete, showPartnerHeader = false }) => {
  const e = encounter;
  const isShared = e.visibility === "shared";
  return (
    <article className="bg-[#161920] border border-white/5 rounded-2xl p-6 space-y-4 hover:border-white/15 transition-colors"
      data-testid={`encounter-card-${e.id}`}>
      <header className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          {showPartnerHeader && e.partner && (
            <Link to={`/profile/${e.partner.id}`} className="flex items-center gap-2 group min-w-0" data-testid={`encounter-partner-${e.id}`}>
              {e.partner.photo && (
                <img src={e.partner.photo} alt="" className="w-8 h-8 rounded-full object-cover border border-white/10" />
              )}
              <span className="text-sm text-[#DCD7D2] group-hover:text-[#C5A880] transition-colors truncate">{e.partner.name}</span>
            </Link>
          )}
          <span className="text-[#C5A880] font-display text-lg">{fmtDate(e.date)}</span>
        </div>
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] uppercase tracking-wider ${
          isShared ? "bg-[#C5A880]/10 border border-[#C5A880]/40 text-[#C5A880]" : "bg-white/5 border border-white/10 text-[#A29F9B]"
        }`} data-testid={`encounter-visibility-${e.id}`}>
          {isShared ? <><Users className="w-3 h-3" /> Partilhado</> : <><Lock className="w-3 h-3" /> Privado</>}
        </span>
      </header>

      {(e.location || e.duration_minutes) && (
        <div className="flex items-center gap-5 text-xs text-[#A29F9B]">
          {e.location && (
            <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{e.location}</span>
          )}
          {e.duration_minutes ? (
            <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" />{e.duration_minutes} min</span>
          ) : null}
        </div>
      )}

      {(e.mood_before || e.mood_after) && (
        <div className="flex items-center gap-2 text-xs text-[#DCD7D2]">
          {e.mood_before && <span className="px-2 py-1 rounded-full bg-white/5">antes: {MOOD_LABEL[e.mood_before] || e.mood_before}</span>}
          {e.mood_before && e.mood_after && <span className="text-[#A29F9B]">→</span>}
          {e.mood_after && <span className="px-2 py-1 rounded-full bg-[#C5A880]/10 text-[#C5A880]">depois: {MOOD_LABEL[e.mood_after] || e.mood_after}</span>}
        </div>
      )}

      {e.rating ? (
        <div className="flex items-center gap-1" data-testid={`encounter-rating-display-${e.id}`}>
          {[1,2,3,4,5].map((n) => (
            <Star key={n} className={`w-4 h-4 ${e.rating >= n ? "text-[#C5A880]" : "text-white/15"}`} fill={e.rating >= n ? "currentColor" : "none"} />
          ))}
        </div>
      ) : null}

      {e.notes && (
        <p className="text-sm text-[#DCD7D2] leading-relaxed whitespace-pre-wrap">{e.notes}</p>
      )}

      <footer className="flex items-center justify-between text-xs text-[#A29F9B] pt-2 border-t border-white/5">
        <span>
          {e.would_meet_again === true  && "Voltaria a sair ✓"}
          {e.would_meet_again === false && "Não voltaria a sair"}
          {e.would_meet_again === null  && ""}
          {!e.is_author && e.author_name && <span className="ml-2">· Escrito por {e.author_name}</span>}
        </span>
        {e.is_author && (
          <div className="flex items-center gap-2">
            <button onClick={()=>onEdit?.(e)} className="hover:text-[#C5A880] transition-colors inline-flex items-center gap-1" data-testid={`encounter-edit-${e.id}`}>
              <Edit3 className="w-3 h-3" /> Editar
            </button>
            <button onClick={()=>onDelete?.(e)} className="hover:text-[#7A2021] transition-colors inline-flex items-center gap-1" data-testid={`encounter-delete-${e.id}`}>
              <Trash2 className="w-3 h-3" /> Apagar
            </button>
          </div>
        )}
      </footer>
    </article>
  );
};

export default EncounterCard;
